// A page translated by the browser (Chrome's Translate swaps every text node for its own <font> elements) or changed by
// an extension: React then removes or inserts next to a node that is no longer where it put it, the browser throws
// "removeChild / insertBefore: not a child of this node", and the uncaught error unmounts the whole app, an empty
// page (report 2026-10-26, a German player in the Themes window; React issue 11538). The known guard: such a call
// leaves the page as it is instead of throwing, and one report a page load says it happened.
import { reportError } from './errorReport';

export function installDomGuard(): void {
  if (typeof Node !== 'function' || !Node.prototype) return;
  let reported = false;
  const report = (what: string) => {
    if (reported) return;
    reported = true;
    reportError('js', `the page was changed by something else (${what} skipped)`, '', { translated: pageTranslated() });
  };
  const removeChild = Node.prototype.removeChild;
  Node.prototype.removeChild = function <T extends Node>(this: Node, child: T): T {
    if (child.parentNode !== this) {
      report('removeChild');
      return child;
    }
    return removeChild.call(this, child) as T;
  };
  const insertBefore = Node.prototype.insertBefore;
  Node.prototype.insertBefore = function <T extends Node>(this: Node, node: T, ref: Node | null): T {
    if (ref && ref.parentNode !== this) {
      report('insertBefore');
      return node;
    }
    return insertBefore.call(this, node, ref) as T;
  };
}

/** Google Translate marks the page `translated-ltr` / `translated-rtl`; Microsoft's (Edge) puts `_msttexthash` on texts. */
export function pageTranslated(): boolean {
  const html = document.documentElement;
  return /\btranslated-(ltr|rtl)\b/.test(html.className) || !!document.querySelector('[_msttexthash]');
}
